import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { IlFrameworkError } from '../../../shared/utils/IlFrameworkError/index.js';

var IlCancelDebounceError = /*#__PURE__*/function (_IlFrameworkError) {
  function IlCancelDebounceError() {
    _classCallCheck(this, IlCancelDebounceError);
    return _callSuper(this, IlCancelDebounceError, ['Client Closed Request']);
  }
  _inherits(IlCancelDebounceError, _IlFrameworkError);
  return _createClass(IlCancelDebounceError);
}(IlFrameworkError);

export { IlCancelDebounceError };
